<template>
    <nav class="site-nav">
        <transition-group class="d-flex" tag="div" :css="false" @before-enter="beforeLinkEnter" @enter="linkEnter" @leave="linkLeave">
            <router-link class="link site-nav-link" key="ruyi" :to="{ name: `${$i18n.locale}.ruyi` }" data-enter="4" v-if="!isHome">{{ $t('pages.ruyi.title') }}</router-link>
            <router-link class="link site-nav-link" key="technology" :to="{ name: `${$i18n.locale}.technology` }" data-enter="3" v-if="!isHome">{{ $t('pages.technology.title') }}</router-link>
            <router-link class="link site-nav-link" key="fashion" :to="{ name: `${$i18n.locale}.fashion` }" data-enter="2" v-if="!isHome">{{ $t('pages.fashion.title') }}</router-link>
            <router-link class="link site-nav-link" key="sustainability" :to="{ name: `${$i18n.locale}.sustainability` }" data-enter="1" v-if="!isHome">{{ $t('pages.sustainability.title') }}</router-link>
        </transition-group>
        <a class="link site-nav-link" :href="$t('links.ruyi-news.url')">{{ $t('links.ruyi-news.title') }}</a>
        <a class="link site-nav-link" :href="$t('links.contact.url')">{{ $t('links.contact.title') }}</a>
    </nav>
</template>

<script>
  import Velocity from 'velocity-animate'

  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters([
        'isHome'
      ])
    },
    methods: {
      beforeLinkEnter (el) {
        el.style.display = 'none'
        el.style.opacity = 0
      },
      linkEnter (el, done) {
        let delay = el.dataset.enter * 150 + 300
        if (this.isHidden) {
          delay += 1000
        }

        setTimeout(() => {
          Velocity(el, {
            opacity: 1,
            translateY: [0, '-100%']
          }, {
            complete: done,
            display: 'block'
          })
        }, delay)
      },
      linkLeave (el, done) {
        el.style.display = 'none'
        done()
      }
    }
  }
</script>

<style lang="scss">
    @import '~@/assets/styles/app';

    .landing-header {
        .site-nav {
            display: none;
            margin-right: 4rem;

            @include media-breakpoint-up(xl) {
                display: flex;
            }

            &-link {
                margin-left: 3rem;

                [lang="en"] & {
                    margin-left: 1rem;
                }

                &:first-child {
                    margin-left: 0;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// SiteNav.vue?d8a415ee